module.exports = __webpack_public_path__ + "public/Icons/precaution_notification.svg?aa027918";